<script>
import 'regenerator-runtime/runtime';
import Axios from '../classes/Axios.js';
import {defineComponent, ref} from 'vue';
import Dialog from '../components/Dialog.vue';

export default defineComponent ({
    name: 'PasswordReset',

    // mixins: [],

    emits: ['onClose', 'onChanged', ],

    components: {
        Dialog,
    },

    props: {
        title: {
            type: String,
            default: 'Password Change',
            required: false,
        },
        userId: {
            type: [String, Number],
            required: false,
            default: null,
        },
        user: {
            type: [Object],
            required: false,
        },
        employeeId: {
            type: [String, Number],
            required: false,
            default: null,
        },
        employee: {
            type: [Object],
            required: false,
        },
        // Changes the view to be more a password reset vs change.
        reset: {
            type: Boolean,
            required: false,
            default: false,
        },
        minLength: {
            type: Number,
            required: false,
            default: 8,
        },
        requireUpperAlpha: {
            type: Boolean,
            required: false,
            default: true,
        },
        requireLowerAlpha: {
            type: Boolean,
            required: false,
            default: true,
        },
        requireNumber: {
            type: Boolean,
            required: false,
            default: true,
        },
        requireSymbol: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            loading: false, // spinner
            iteration: 0,
            // locale: window.navigator.userLanguage || window.navigator.language || 'en-US', // 'fr-fr' // test stuff
            oasisV3Api: new Axios('/restv3'),

            password: '',
            repeatPassword: '',
            currentPassword: '',
            last4: '',

            // Dialog
            toast: false,
            toastMessage: '',
            toastClass: 'toast-success',
            // user: user,
            // employee: employee,
            errors: {
                password: '',
                repeatPassword: '',
                currentPassword: '',
                last4: '',
            }
        }
    },

    computed: {
        type() {
            return this.userId ? 'employer' : (this.employeeId ? 'employee' : null);
        },
        email() {
            return this.userId && this.user ? this.user.email : (this.employeeId && this.employee ? this.employee.email : '');
        },
        isSsnNeeded() {
            return this.type === 'employee';
        },
        isCurrentPasswordNeeded() {
            return this.type === 'employer';
        },
        isPasswordMatch() {
            return this.password && this.repeatPassword && this.password === this.repeatPassword;
        },
        isPasswordComplex() {
            if (
                typeof this.password !== 'string' ||
                this.password.length < this.minLength ||
                this.requireUpperAlpha && !this.password.match(/[A-Z]/) ||
                this.requireLowerAlpha && !this.password.match(/[a-z]/) ||
                this.requireNumber && !this.password.match(/[0-9]/) ||
                this.requireSymbol && !this.password.match(/[$!#"'_,+-\.\?]/)
            ) {
                return false;
            } else {
                return true;
            }
        },
        isFormComplete() {
            if (!this.password || !this.repeatPassword || !this.isPasswordMatch) return false;
            if (this.isSsnNeeded && !this.last4) return false;
            if (this.isCurrentPasswordNeeded && !this.currentPassword) return false;

            return true;
        },
    },

    methods: {
        checkForm() {
            let errors;

            for (const i in this.errors) {
                this.errors[i] = null;
            }
            if (this.userId && !this.user) {
                // Something wrong.  Hack?
                return false;
            } else if (this.employeeId && !this.employee) {
                // Something wrong.  Hack?
                return false;
            }
            if (!this.password) {
                this.errors.password = 'Please enter a password.';
                errors = true;
            }
            if (!this.repeatPassword) {
                this.errors.repeatPassword = 'Please enter your password again.';
                errors = true;
            }
            if (this.password !== this.repeatPassword) {
                this.errors.repeatPassword = 'Your passwords do not match.';
                errors = true;
            }
            if (this.isCurrentPasswordNeeded && !this.currentPassword) {
                this.errors.currentPassword = 'Please enter your current password.';
                errors = true;
            }
            if (this.isSsnNeeded && !this.last4) {
                this.errors.last4 = 'Please enter the last 4 of your SSN.';
                errors = true;
            }
            if (typeof this.password !== 'string' || this.password.length < this.minLength) {
                this.errors.password = `Please make sure your password is at least ${this.minLength} characters long.`;
                errors = true;
            }
            if (this.requireUpperAlpha && !this.password.match(/[A-Z]/)) {
                this.errors.password = 'Please make sure your password contains 1 upper case letter.';
                errors = true;
            }
            if (this.requireLowerAlpha && !this.password.match(/[a-z]/)) {
                this.errors.password = 'Please make sure your password contains 1 lower case letter.';
                errors = true;
            }
            if (this.requireNumber && !this.password.match(/[0-9]/)) {
                this.errors.password = 'Please make sure your password contains 1 number.';
                errors = true;
            }
            if (this.requireSymbol && !this.password.match(/[$!#"'_,+-\.\?]/)) {
                this.errors.password = 'Please make sure your password contains 1 symbol ($!#"\'_,+-.?).';
                errors = true;
            }

            return errors ? false : true;
        },

        redirectHome() {
           setTimeout(() => { window.location.href = '/logout' }, 3000);
        },

        async submit() {
            const test = this.checkForm();
            if (test === false) {
                this.showToast('Please note missing or correct data before submitting.');
                return;
            }

            let message;
            try {
                const data = {
                    currentPassword: this.currentPassword,
                    password: this.password
                }
                const response = await this.oasisV3Api.post(`/employer/users/change`, data);
                if (response && (response.status === 200 || response.status === 201)) {
                    message = 'Password updated.  Logging out in 3 seconds';
                    this.redirectHome();
                    // this.$emit('onSave', this.assignment.id, this.changed);
                } else {
                    message = response.data.message || response.message || `Error Updating password.`;
                    if (response.data.field) {
                        this.errors[field] = message;
                    }
                }
            } catch (error) {
                console.log(error);
                message = `Error Updating password.`;
            } finally {
                this.loading = false;
            }
            if (message)this.showToast(message);

            return;
        },

        showToast(message) {
            this.toastMessage = message;
            this.toast = true;
            setTimeout(() => {
                this.message = '';
                this.toast = false;
            }, 1000 * 3);
        },

        dialogOpen(ref=null) {
            const dialog = this.$refs[ref];
            if (dialog) dialog.openDialog();
        },

        dialogClose(ref=null) {
            const dialog = this.$refs[ref];
            if (dialog) dialog.closeDialog();
        },

        dialogDiscard(ref=null, direction='next') {
            const dialog = this.$refs[ref];
            if (dialog) {
                this.dialogClose(ref);
                this.modified = false;
                if (direction === 'next' && this.nextStart) {
                    this.gotoNextStart();
                }
                if (direction === 'prev' && this.prevStart) {
                    this.gotoPrevStart();
                }
            }
        },

        async dialogSave(ref=null, direction='next') {
            const dialog = this.$refs[ref];
            if (dialog) {
                this.dialogClose(ref);
                await this.save();
                if (direction === 'next' && this.nextStart) {
                    this.gotoNextStart();
                }
                if (direction === 'prev' && this.prevStart) {
                    this.gotoPrevStart();
                }
            }
        },
    },

    // watch: { },

    async created() {},

    async mounted() {
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip() }, 500);

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };
    }
});
</script>

<template>
<div>
    <span v-if="toast" :class="toastClass" v-html="toastMessage"></span>
    <div class="container">
        <h2>Change Your <span class="red">Password</span></h2>
        <p class="lead">Please fill out the form to complete your password change.</p>
        <p class="lead">Passwords should contain at least:</p>
        <ul class="m-left-50 bigger" style="display: block !important; list-style-type: disc;">
            <li>{{ this.minLength }} characters</li>
            <li v-if="requireUpperAlpha">1 upper case character</li>
            <li v-if="requireLowerAlpha">1 lower case letter</li>
            <li v-if="requireNumber">1 number</li>
            <li v-if="requireSymbol">1 symbol</li>
            <!-- <li>They should be long (at least 24 characters) and tough to guess but easy to remember.  For instance, <br /><span class="italic bold">“Mother really loved Apples”</span> is much tougher to crack, better to type, and easier to recall than “!ZrV#fj8@B”.</li> -->
        </ul>
        <div class="container">
            <div class="form-group m-top-20" style="width: 600px;">
                <!-- <form class="form-horizontal" id="passwordForm" action="#" role="form" method="post"> -->
                    <div class="control-group">
                        <label for="email" class="col-sm-4 control-label">Email</label>
                        <div class="controls col-sm-8 m-bottom-10">
                            <input class="form-control" type="text" name="email" id="email" :value="email" readonly/>
                            <div class="alert alert-warning" v-if="errors.email" id="email_alert"><strong>Warning!</strong> {{ errors.email }}</div>
                        </div>
                    </div>
                    <div class="control-group" v-if="type === 'employer'">
                        <label for="password" class="col-sm-4 control-label">Current Password</label>
                        <div class="controls col-sm-8 m-bottom-10">
                            <input autocomplete="off" class="form-control" type="password" name="currentPassword" v-model="currentPassword" required />
                            <div class="alert alert-warning" v-if="errors.currentPassword" id="currentPassword_alert"><strong>Warning!</strong> {{ errors.currentPassword }}</div>
                        </div>
                    </div>
                    <div class="control-group">
                        <label for="password" class="col-sm-4 control-label">New Password</label>
                        <div class="controls col-sm-8 m-bottom-10">
                            <input autocomplete="off" class="form-control" type="password" name="password" v-model="password" required />
                            <div class="alert alert-warning" v-if="errors.password" id="password_alert"><strong>Warning!</strong> {{ errors.password }}</div>
                        </div>
                    </div>
                    <div class="control-group">
                        <label for="repeatPassword" class="col-sm-4 control-label">Repeat Password</label>
                        <div class="controls col-sm-8 m-bottom-10">
                            <input autocomplete="off" class="form-control" type="password" name="repeatPassword" v-model="repeatPassword" required />
                            <div class="alert alert-warning" v-if="errors.repeatPassword" id="repeatPassword_alert"><strong>Warning!</strong> {{ errors.repeatPassword }}</div>
                        </div>
                    </div>
                    <div class="control-group" v-if="type === 'employee'">
                        <label for="last4" class="col-sm-4 control-label">Last 4 of your SSN/SIN</label>
                        <div class="controls col-sm-8 m-bottom-10">
                            <input class="form-control" type="text" name="last4" v-model="last4" placeholder="XXXX" required />
                            <div class="alert alert-warning" v-if="errors.last4" id="last4_alert"><strong>Warning!</strong> {{ errors.last4 }}</div>
                        </div>
                    </div>
                <!-- </form> -->
                <div class="control-group">
                    <div class="m-top-30 m-right-20 right">
                        <button class="btn btn-primary shadow big-btn-text" name="register" @click="submit" id="submitButton"><span v-if="reset">Reset</span><span v-else>Change</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Dialog ref="saveDialog" @close="dialogClose('saveDialog')">
        <!-- Main content here -->
        <p>Your data has changed.  Please choose to either Review, Discard, or Save your changes.</p>
    
        <!-- Custom buttons via named slot -->
        <template #footer-buttons>
            <button class="btn btn-default m-right-5" @click="dialogClose('saveDialog')">Review</button>
            <div v-if="true">
                <button class="btn btn-danger m-right-5" @click="dialogDiscard('saveDialog')">Discard and Next</button>
                <button class="btn btn-primary" @click="dialogSave('saveDialog')">Save and Next</button>
            </div>
            <div v-else>
                <button class="btn btn-primary" @click="dialogSave('saveDialog', null)">Save</button>
            </div>
        </template>
    </Dialog>
</div>
</template>

<style>
.m-top-m5 {
    margin-top: -5px
}
.reviewBox {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    top: 100px;
    z-index: 1000;
    border: 2px solid red;
    border-radius: 10px;
    box-shadow: 0px 0px 500px 100px #666;
    padding: 20px;
    background-color: white;
    width: 1500px;
    max-width: 90%;
}
.option {
    font-size: 1.1em;
    font-weight: bold;
    text-decoration: underline;
}
.info {
    font-weight: lighter;
}
.toast-success {
    position: fixed; top: 5%; left: 50%; transform: translate(-50%, -50%);
    background-color: #d6e9c6; z-index: 1001; border-radius: 10px; padding: 20px; max-width: 40%;
    font-size: 1.5em; font-weight: 1000; text-align: center;
}
.toast-error {
    position: fixed; top: 5%; left: 50%; transform: translate(-50%, -50%);
    background-color: #feeeee; z-index: 1001; border-radius: 10px; padding: 20px; max-width: 40%;
    font-size: 1.5em; font-weight: 1000; text-align: center;
}
</style>
